import { z } from "zod";

import { ConsentDocumentType } from "@/src/models/constants/document-types";
import { DatabaseDefaults } from "@/src/models/database-defaults";
import { DocumentDateSchema } from "@/src/models/documents/document-dates";
import { Patient, patientMinimalSchema } from "@/src/models/patient";

export const consentTypeDisplay: Record<ConsentDocumentType, string> = {
  [ConsentDocumentType.CONSENT]: "Consent",
};

export const consentSchema = z.object({
  patient: patientMinimalSchema,
  type: z.string().nullable(),
  dateSigned: DocumentDateSchema.shape.dateSigned,
  dateReceived: DocumentDateSchema.shape.dateReceived,
  dateOfEvent: DocumentDateSchema.shape.dateOfEvent,
  nameOfDocument: z.string().nullable(),
});

export type Consent = Omit<z.infer<typeof consentSchema>, "patient"> & {
  patient: Patient | null;
} & DatabaseDefaults;

export const consentShape: Consent = {
  id: "",
  patient: null,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  groupId: "",
  type: null,
  dateSigned: null,
  dateReceived: null,
  dateOfEvent: null,
  nameOfDocument: null,
};
